// MUI
import { Box } from "@mui/material";

// Components
import SingleTokenFieldVariant from "@Settings/Layouts/FormVariants/SingleTokenFieldVariant";
import BasicAuthVariant from "@Settings/Layouts/FormVariants/BasicAuthVariant";

// Types
import { AuthenticationType } from "@Settings/types/Common/auth";
import { AuthRoleStatus, TSelectedProvider } from "@Settings/types/administrationTools/utils";

type ProviderLoginProps = Readonly<{
	authType?: AuthenticationType;
	isError: boolean;
	error: Error | null;
	disabled: boolean;
	isLoading: boolean;
	placeholder?: string;
	buttonType?: "submit" | "button";
	selectedProvider: (Partial<TSelectedProvider> & { authRoleStatuses: AuthRoleStatus[] }) | null;
}>;

export default function providerLoginComponent(props: ProviderLoginProps) {
	const { authType } = props;

	let loginComponent;

	switch (authType) {
		case "tokenAuth":
			loginComponent = (
				<SingleTokenFieldVariant
					{...props}
					buttonClasses={{
						root: "!bg-primary !font-sans !font-normal !text-sm !rounded-[6px] !mt-8 !capitalize !h-[30px] !shadow-none",
						disabled: `disabled:!bg-[#cccccc] disabled:!text-white`,
					}}
				/>
			);
			break;
		case "basicAuth":
			loginComponent = (
				<BasicAuthVariant
					{...props}
					buttonClasses={{
						root: "!bg-primary !font-sans !font-normal !text-sm !rounded-[6px] !mt-8 !capitalize !h-[30px] !shadow-none",
						disabled: `disabled:!bg-[#cccccc] disabled:!text-white`,
					}}
				/>
			);
			break;
		default:
			loginComponent = <Box></Box>;
			break;
	}

	return loginComponent;
}
